// Whether the live updates socket is open, for the polling intervals and the
// status badge. realtime.ts owns the socket and is the only writer.
import { useSyncExternalStore } from 'react'

// connecting: the first attempt. live: the socket is open. offline: it
// dropped and a retry is scheduled.
export type LiveState = 'connecting' | 'live' | 'offline'

let state: LiveState = 'connecting'
const listeners = new Set<() => void>()

export function setLiveState(s: LiveState) {
  if (state === s) return
  state = s
  listeners.forEach((l) => l())
}

function subscribe(l: () => void) {
  listeners.add(l)
  return () => listeners.delete(l)
}

export function useLiveState(): LiveState {
  return useSyncExternalStore(subscribe, () => state, () => 'connecting')
}
